module.exports = __webpack_public_path__ + "static/greentelcom-3d76410747ecba140e4b532474c9abdb.png";